import {
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View
} from 'react-native'

// styles
import { globalStyles } from '../../../static/styles/global'

// components
import ModalPopup from './ModalPopup'

interface modalConfirmProps {
  progress: number
  message: string
  visible: boolean
  setVisible?: any
}

const ModalProgress = ({
  progress,
  message,
  visible,
  setVisible
}: modalConfirmProps): JSX.Element => {
  return (
    <ModalPopup visible={visible}>
      <View style={[styles.body]}>
        <View>
          <Text style={[globalStyles.text, globalStyles.textCenter]}>
            {`${message} ${progress}%`}
          </Text>
        </View>
      </View>
    </ModalPopup>
  )
}

const styles = StyleSheet.create({
  body: {
    paddingVertical: 30,
    paddingHorizontal: 20
  }
})

export default ModalProgress
